<template>
  <vue-dropzone
    ref="myVueDropzone"
    :id="`dropzone${index}`"
    :useCustomSlot="true"
    :options="dropzoneOptions"
    @vdropzone-upload-progress="uploadProgress"
    @vdropzone-file-added="fileAdded"
    @vdropzone-files-added="filesAdded"
    @vdropzone-success="success"
    @vdropzone-error="error"
    @vdropzone-canceled="canceled"
    @vdropzone-complete="complete"
    @vdropzone-sending="sending"
    @vdropzone-queue-complete="queueComplete"
  >
    <slot></slot>
  </vue-dropzone>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'uploader',
  props: ['dropzoneOptions', 'requestUrl', 'index'],
  data() {
    return {}
  },
  methods: {
    fileAdded(file) {
      this.$emit('addFile', file)
    },
    filesAdded(file) {
      this.$emit('addFiles', file)
    },
    sending(file, xhr, formData) {
      this.$emit('uploadSending', file, xhr, formData)
    },
    uploadProgress(file, progress, bytesSent) {
      this.$emit('uploadProgress', file, progress, bytesSent)
    },
    success(file, response) {
      this.$emit('uploadSuccess', file, response)
    },
    error(file, message, xhr) {
      this.$refs.myVueDropzone.removeAllFiles(true)
      this.$emit('uploadError', file, message, xhr)
    },
    canceled(file) {
      this.$emit('uploadCanceled', file)
    },
    complete(response) {
      this.$emit('uploadComplete', response)
    },
    cancelUpload() {
      this.$refs.myVueDropzone.removeAllFiles(true)
    },
    processQueue() {
      this.$refs.myVueDropzone.processQueue()
    },
    removeAllFiles() {
      this.$refs.myVueDropzone.removeAllFiles(true)
    },
    getAcceptedFiles() {
      return this.$refs.myVueDropzone.getAcceptedFiles()
    },
    queueComplete() {
      this.$emit('queueComplete')
      this.removeAllFiles()
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  }
}
</script>
<style lang="scss">
.vue-dropzone {
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
}
</style>
